module.exports = __webpack_public_path__ + "img/cara-neutral.babb0e56.svg";